import { fetchCreateClub } from "@/api/merchant/request.post";
import BoxKit from "@/shared/components/kit/box";
import CustomButton from "@/shared/components/kit/button";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { CircularProgress, Grid, TextField } from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { useState } from "react";
import { toast } from "react-toastify";
import UploadDocuments from "./uploadImg";
/**
 * Content
 *
 * فرم ایجاد سازمان جدید شامل ورودی نام سازمان و بارگذاری تصویر.
 * داده‌ها به‌صورت Base64 ارسال شده و پس از موفقیت پیام مناسب نمایش داده می‌شود.
 *
 * @returns JSX.Element
 */

const Content = () => {
  const [clubId, setClubId] = useState("");

  const [uploadedImages, setUploadedImages] = useState<File | null>(null);

  const handleFile = (file: any) => {
    setUploadedImages(file);
  };

  const { mutate: submitFormRegisterGroup, isPending: isPendingLogin } = useMutation({
    mutationFn: fetchCreateClub,
    onSuccess: (data: any) => {
      toast.success("سازمان با موفقیت ثبت شد")
    },
    onError: (error: AxiosError<{ message: string }>) => {
      toast.error(error?.response?.data?.message || "خطا در ثبت اطلاعات");
    },
  });

  const handleSubmitSendData = () => {
    const reader = new FileReader();
    reader.onloadend = () => {
      const base64String = reader.result as string;
      submitFormRegisterGroup({
        image: base64String,
        title: clubId,
      });
    };
    if (uploadedImages)
      reader.readAsDataURL(uploadedImages);
  };

  return (
    <Grid container spacing={4}>
      {/* عنوان صفحه */}
      <Grid size={12}>
        <StackKit alignItems={"start"}>
          <TypoGraphyKit variant="body1">افزودن سازمان جدید</TypoGraphyKit>
          <TypoGraphyKit variant="body1">پذیرنده گرامی ؛</TypoGraphyKit>
          <TypoGraphyKit variant="body1">
            در این بخش شما میتوانید سازمان جدید خود را ایجاد نمایید.
          </TypoGraphyKit>
        </StackKit>
      </Grid>

      {/* نام سازمان */}
      <Grid size={12}>
        <StackKit direction={{ xs: "column", sm: "row" }} gap={2} alignItems={{ xs: "start", sm: "center" }}>
          <BoxKit sx={{textAlign: "right" }}>
            <TypoGraphyKit>نام سازمان مورد نظر را وارد نمایید.</TypoGraphyKit>
          </BoxKit>
          <TextField className="w-full max-w-[500px]" fullWidth onChange={(e) => setClubId(e.target.value)}/>
        </StackKit>
      </Grid>

      {/* بارگذاری تصویر */}
      <Grid size={12} sx={{ display: "flex", justifyContent: "center", alignItems: "center" }} gap={2}>
        {/* <BoxKit sx={{ width: "400px", textAlign: "right", bgcolor: "green" }}></BoxKit> */}
        <StackKit >
          <UploadDocuments label="" defaultImage={""}
            onUpload={(file: any) => {
              setUploadedImages((prev: any) => file);
            }}
          />
        </StackKit>
      </Grid>

      {/* دکمه */}
      <Grid size={12}>
        <StackKit width={"100%"} alignItems={{ xs: "center", sm: "end" }}>
          <CustomButton sx={{ width: { xs: "100%", sm: "fit-content" }, minWidth: "120px", }} onClick={handleSubmitSendData} disabled={!uploadedImages || !clubId} >
            {isPendingLogin ? (
              <CircularProgress sx={{ color: "#fff" }} size={24} />
            ) : (
              <TypoGraphyKit variant="body1">ثبت سازمان</TypoGraphyKit>
            )}
          </CustomButton>
        </StackKit>
      </Grid>
    </Grid>

  );
};

export default Content;
